import { useState } from "react";
import { Button, useNotify } from "react-admin";
import { DeleteOutlineOutlined } from '@mui/icons-material';
import ConfirmDeletePanelModal from "./ConfirmDeletePanelModal";

const DeletePanelButton = ({ record }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const notify = useNotify();
    
    const labName = record?.lab?.name;

    const handleOpenModal = async () => {
        setLoading(true);
        try {
            const apiUrl = process.env.REACT_APP_API_URL || '';
            
            const validateResponse = await fetch(`${apiUrl}/orders/count-by-panel/${record.id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            });

            if (!validateResponse.ok) {
                throw new Error('Erro ao validar exclusão do painel');
            }

            const validationData = await validateResponse.json();
            
            if (!validationData.ordersCount?.canDelete) {
                const errorMessage = validationData.ordersCount?.message || validationData.message || 'Não é possível deletar painel com pedidos associados';
                notify(errorMessage, { type: 'warning' });
                return;
            }

            setModalOpen(true);
            
        } catch (error) {
            notify(error.message || 'Erro ao validar exclusão do painel', { type: 'warning' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button
                type="button"
                onClick={handleOpenModal}
                color="error"
                variant="outlined"
                label="Excluir Painel"
                disabled={loading}
            >
                <DeleteOutlineOutlined />
            </Button>
            {modalOpen && (
                <ConfirmDeletePanelModal 
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    panelId={record.id}
                    panelName={record.name}
                    labName={labName}
                />
            )}
        </>
    );
};

export default DeletePanelButton;
